/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Select, InputNumber, Modal} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {materialScreening2} from '../../service/inventoryQuery';
import {getDealerList, deleteList, update, insert} from '../../service/dealer';
import {Store, Actions} from './store';

class Dealer extends React.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            opts: ['经销商信息维护'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            visible: false,
            total: 1,
            saveVisible: false,
            upLineNum: 0,
            downLineNum: 0,
            id: 0,
            transferVisible: true,
            tiaozheng: [{id: '', count: ''}],
            searchObj: {
                s: 10,
                p: 1,
            },
            params: {
                companyName: '',
                telephone: '',
                address: '',
                linkman: '',
                status: 'true'
            },
            objType_type: [],
            objType_type2: [],
            categoryData: [],
            button_limits_end: {},
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goView(url) {
        hashHistory.push(url);
    }

    goAdd() {
        let self = this;
        tiaozhengAdd(this.state.tiaozheng).then((result) => {
            if (result && result.code == 200) {
                openNotice('success', (result && result.message) ? result.message : '', '');
                self.initData();
            } else {
                openNotice('error', (result && result.message) ? result.message : '', '');
            }
        })
        this.setState({saveVisible: !this.state.saveVisible});
    }

    goChange() {
        this.setState({saveVisible: true, transferVisible: false});

    }

    changeAmount = (record, e) => {
        // if (e.target.value < 0){
        // 	openNotice('warning', '数量不能为负数！');
        // 	return;
        // } else if (record.count < e.target.value) {
        // 	openNotice('warning', '调整库存不能大于现有量！');
        // 	return;
        // } else {
        let arr = [];
        let obj = {};
        obj.id = record.id;
        obj.count = e.target.value;
        arr.push(obj);
        this.setState({tiaozheng: arr});
        // }
    }

    goDelete() {
        alert('正在删除');
    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            params: {
                companyName: '',
                telephone: '',
                address: '',
                linkman: '',
            },
            searchObj: {
                ...this.state.searchObj,
                p: 1,
                s: 10
            }
        }, function () {
            self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    updateProductStatusFn(key) {
        /* 产品上下架 */
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        if (key == 'up') {
            setProductUp(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '上架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '上架操作失败', (result && result.message) ? result.message : '');
                }
            });
        } else {
            setProductDown(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '下架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '下架操作失败', (result && result.message) ? result.message : '');
                }
            });
        }
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        getDealerList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                this.setState({loading: false});
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    searchHandler = () => {
        // debugger;
        this.setState({visible: true, id: 0})
    }
    deletedFn = (id) => {
        let self = this;
        this.setState({loading: true});
        deleteList(id).then((result) => {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '')
                self.initData();
            } else {
                openNotice('error', result.message || '', '');
                this.setState({loading: true});
            }
        })
    };
    exit = (record) => {
        const {params} = this.state;
        params.companyName = record.companyName;
        params.address = record.address;
        params.telephone = record.telephone;
        params.linkman = record.linkman;
        params.status = record.status ? 'true' : 'false';
        this.state.id = record.id;
        this.setState({params: this.state.params, id: this.state.id, visible: true});
    }
    companyNameChange = (e) => {
        this.setState({params: {...this.state.params, companyName: e.target.value}});
    }
    addressChange = (e) => {
        this.setState({params: {...this.state.params, address: e.target.value}});
    }
    phoneChange = (e) => {
        this.setState({params: {...this.state.params, telephone: e.target.value}});
    }
    linkmanChange = (e) => {
        this.setState({params: {...this.state.params, linkman: e.target.value}});
    }
    mainChange = (value) => {
        this.setState({params: {...this.state.params, status: value}});
    }
    handleT = () => {
        let self = this;
        if (self.state.params.companyName == '') {
            openNotice('warning', '请输入公司名称', '');
            return;
        }
        if (self.state.params.address == '') {
            openNotice('warning', '请输入联系地址', '');
            return;
        }
        if (self.state.params.telephone == '') {
            openNotice('warning', '请输入联系电话', '');
            return;
        }
        if (self.state.params.linkman == '') {
            openNotice('warning', '请输入联系人', '');
            return;
        }
        if (this.state.id == 0) {
            insert(this.state.params).then((result) => {
                if (result && result.code == 200) {
                    self.initData();
                    this.setState({visible: false});
                    this.resetParams();
                }
            })
        } else {
            this.setState({params: {...this.state.params, id: this.state.id}}, function () {
                update(this.state.params).then((result) => {
                    if (result && result.code == 200) {
                        self.initData();
                        this.setState({visible: false});
                        this.resetParams();
                    }
                })
            })
        }
    }
    resetParams = () => {
        this.setState({
            params: {
                ...this.state.params,
                companyName: '',
                telephone: '',
                address: '',
                linkman: '',
                status: 'true'
            }
        });
    }
    handleF = () => {
        this.setState({visible: false});
        this.resetParams();
    }

    render() {
        const {
            opts, key, visible, rows, total, searchObj, saveVisible, transferVisible,
            params,
            selectedRowKeys, objType_type, button_limits_end, loading
        } = this.state;
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '经销商公司名称',
                    dataIndex: 'companyName',
                }, {
                    title: '联系地址',
                    dataIndex: 'address',
                }, {
                    title: '联系电话',
                    dataIndex: 'telephone',
                }, {
                    title: '联系人',
                    dataIndex: 'linkman',
                },
                {
                    title: '是否主要',
                    dataIndex: 'status',
                    render: text => text ? <span>是</span> : <span>否</span>
                },
                {
                    title: '操作',
                    dataIndex: '',
                    render: (text, record, index) => <span>
            <Button onClick={this.deletedFn.bind(this, record.id)}>删除</Button>&nbsp;
                        <Button onClick={this.exit.bind(this, record)}>编辑</Button></span>

                }

            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                {/* { <Button onClick={this.goAdd.bind(this)} style={{display: saveVisible ? 'inline-block' : 'none'}} >保存</Button>}
         { button_limits_end.stockControl_list_02 && <Button onClick={this.goChange.bind(this)} style={{display: saveVisible ? 'none' : 'inline-block'}}>库存调整</Button>}
         { button_limits_end.stockControl_list_03 && <Button onClick={this.goView.bind(this, '/stockControl/sublibraryTransfer')}>子库转移</Button>}
         { button_limits_end.stockControl_list_04 && <Button onClick={this.goView.bind(this, '/stockControl/sundryInStorage')}>杂项入库</Button>} */}
            </DmsTab>
            <div className="dms-table-box">
                <div style={{marginBottom: 8}}>
                    {<Button onClick={this.searchHandler}>新增</Button>}
                </div>
                <TableView {...tableViewProps} />
            </div>
            <Modal
                visible={visible}
                maskClosable={false}
                onOk={this.handleT}
                onCancel={this.handleF}
                // width={width}
                // footer={null}
            >
                <DmsTab className="white-bg no-border" options={['经销商信息']} defaultKey={0}/>
                <div className="approve_modal" style={{marginTop: '20px', width: '300px'}}>
                    <label>经销商公司名称</label>
                    <div style={{paddingLeft: '100px'}}>
                        <input type='default' onChange={this.companyNameChange.bind(this)} placeholder='请输入公司名称'
                               value={params.companyName}/>
                    </div>
                </div>
                <div className="approve_modal" style={{marginTop: '20px', width: '300px'}}>
                    <label>联系地址</label>
                    <div style={{paddingLeft: '100px'}}>
                        <input type='default' style={{textAlign: 'middle', width: '300px'}}
                               value={params.address}
                               onChange={this.addressChange.bind(this)} placeholder='请输入联系地址'
                        />
                    </div>
                </div>
                <div className="approve_modal" style={{marginTop: '20px', width: '300px'}}>
                    <label>联系电话</label>
                    <div style={{paddingLeft: '100px'}}>
                        <input type='default' style={{textAlign: 'middle', width: '300px'}}
                               value={params.telephone}
                               onChange={this.phoneChange.bind(this)} placeholder='请输入联系电话'
                        />
                    </div>
                </div>
                <div className="approve_modal" style={{marginTop: '20px', width: '300px'}}>
                    <label>是否主要</label>
                    <div style={{paddingLeft: '100px'}}>
                        <Select type='select' style={{textAlign: 'middle', width: '50px'}}
                                value={params.status}
                                onChange={this.mainChange.bind(this)}>
                            <Select.Option value='true'>是</Select.Option>
                            <Select.Option value='false'>否</Select.Option>
                        </Select>
                    </div>
                </div>
                <div className="approve_modal" style={{marginTop: '20px', width: '300px'}}>
                    <label>联系人</label>
                    <div style={{paddingLeft: '100px'}}>
                        <input type='default' style={{textAlign: 'middle', width: '300px'}}
                               value={params.linkman}
                               onChange={this.linkmanChange.bind(this)} placeholder='请输入联系人'
                        />
                    </div>
                </div>
            </Modal>
        </div>
    }
}
;
export default Dealer;


// WEBPACK FOOTER //
// ./src/routes/dealer/dealer.js